import React, { useState } from 'react';

import { BsChevronDown, BsChevronUp } from 'react-icons/bs';

export const SkiInfo = ({ skiReports }) => {
  const [opened, setOpened] = useState([]);

  return (
    <div className="h-100 w-100 d-flex flex-column">
      {skiReports.map((report, index) => {
        return (
          <div className="p-2 mb-4 bg-primary rounded" key={index}>
            <div className="d-flex justify-content-center flex-column">
              <div
                className="d-flex flex-row cursor-pointer align-items-center justify-content-between "
                onClick={() => {
                  const newOpened = [...opened];
                  newOpened[index] = !newOpened[index];
                  setOpened(newOpened);
                }}
              >
                <div className="h3 ms-2 fw-bold m-auto">{report.ski_area_name}</div>
                {opened[index] ? <BsChevronUp /> : <BsChevronDown />}
              </div>
              {opened[index] && (
                <div>
                  <div className="d-flex flex-column flex-lg-row mt-3">
                    <div className="ms-4 mt-4 mt-lg-0 w-100">
                      <div className="h4 fw-bold">Snow Details</div>

                      <div className="d-flex flex-column gap-3 flex-wrap">
                        {report.new_snow_min24 && report.new_snow_min24 !== '*' && (
                          <div>New snow min: {report.new_snow_min24}</div>
                        )}
                        {report.new_snow_max24 && report.new_snow_max24 !== '*' && (
                          <div>New snow max: {report.new_snow_max24}</div>
                        )}
                        {report.primary_surface && report.primary_surface !== '*' && (
                          <div>Primary Surface: {report.primary_surface}</div>
                        )}
                        {report.base_depth_min && report.base_depth_min !== '*' && (
                          <div>Base depth min: {report.base_depth_min}</div>
                        )}
                        {report.base_depth_max && report.base_depth_max !== '*' && (
                          <div>Base depth max: {report.base_depth_max}</div>
                        )}
                        {report.snow_making && report.snow_making !== '*' && (
                          <div>Snow making: {report.snow_making}</div>
                        )}
                        {!(report.new_snow_min24 && report.new_snow_min24 !== '*') &&
                          !(report.new_snow_max24 && report.new_snow_max24 !== '*') &&
                          !(report.primary_surface && report.primary_surface !== '*') &&
                          !(report.base_depth_min && report.base_depth_min !== '*') &&
                          !(report.base_depth_max && report.base_depth_max !== '*') &&
                          !(report.snow_making && report.snow_making !== '*') && (
                            <div>No data.</div>
                          )}
                      </div>
                    </div>
                    <div className="ms-4 mt-4 mt-lg-0 w-100">
                      <div className="h4 fw-bold">Historic</div>

                      <div className="d-flex flex-column gap-2   flex-wrap">
                        {report.seasonal_snowfall && report.seasonal_snowfall !== '*' && (
                          <div>Seasonal Snowfall: {report.seasonal_snowfall} in.</div>
                        )}
                        {report.last_snowfall_date && report.last_snowfall_date !== '*' && (
                          <div>Last Snowfall Date: {report.last_snowfall_date}</div>
                        )}
                        {report.last_snowfall_amount && report.last_snowfall_amount !== '*' && (
                          <div>Last Snowfall Amount: {report.last_snowfall_amount} in.</div>
                        )}
                        {report.previous_snowfall_date && report.previous_snowfall_date !== '*' && (
                          <div>Previous Snowfall Date: {report.previous_snowfall_date}</div>
                        )}
                        {report.previous_snowfall_amount &&
                          report.previous_snowfall_amount !== '*' && (
                            <div>
                              Previous Snowfall Amount: {report.previous_snowfall_amount} in.
                            </div>
                          )}
                        {!(report.seasonal_snowfall && report.seasonal_snowfall !== '*') &&
                          !(report.last_snowfall_date && report.last_snowfall_date !== '*') &&
                          !(report.last_snowfall_amount && report.last_snowfall_amount !== '*') &&
                          !(
                            report.previous_snowfall_date && report.previous_snowfall_date !== '*'
                          ) &&
                          !(
                            report.previous_snowfall_amount &&
                            report.previous_snowfall_amount !== '*'
                          ) && <div>No data.</div>}
                      </div>
                    </div>
                  </div>
                  <div className="ms-4 mt-4 mt-lg-0 align-items-start">
                    <div className="h4 fw-bold">Operation</div>
                    <div className="d-flex flex-column gap-2 flex-wrap align-items-start justify-content-start">
                      {report.operation_hours && report.operation_hours !== '*' && (
                        <div>Operation Hours: {report.operation_hours}</div>
                      )}
                      {report.operation_status && report.operation_status !== '*' && (
                        <div>Operation status: {report.operation_status}</div>
                      )}
                      {report.resort_status && report.resort_status !== '*' && (
                        <div>Resort Status: {report.resort_status}</div>
                      )}
                      {report.projected_operations && report.projected_operations !== '*' && (
                        <div>Projected Operation: {report.projected_operations}</div>
                      )}
                      {report.snow_comments24 && report.snow_comments24 !== '*' && (
                        <div>Snow Comments: {report.snow_comments24}</div>
                      )}
                      {report.general_comments && report.general_comments !== '*' && (
                        <div>General Comments: {report.general_comments}</div>
                      )}
                      {report.night_skiing && report.night_skiing !== '*' && (
                        <div>Night skiing: {report.night_skiing}</div>
                      )}
                      {report.num_lift_open && report.num_lift_open !== '*' && (
                        <div>Lift Open: {report.num_lift_open}</div>
                      )}
                      {report.num_trails_open && report.num_trails_open !== '*' && (
                        <div>Trails Open: {report.num_trails_open}</div>
                      )}
                      {report.num_miles_open && report.num_miles_open !== '*' && (
                        <div>Miles Open: {report.num_miles_open}</div>
                      )}
                      {report.num_acres_open && report.num_acres_open !== '*' && (
                        <div>Acres Open: {report.num_acres_open}</div>
                      )}
                      {report.percent_runs_open && report.percent_runs_open !== '*' && (
                        <div>% Runs Open: {report.percent_runs_open}%</div>
                      )}
                      {report.cross_country && report.cross_country !== '*' && (
                        <div>Crosscountry: {report.cross_country}</div>
                      )}
                      {report.snow_boarding && report.snow_boarding !== '*' && (
                        <div>Snowboarding: {report.snow_boarding}</div>
                      )}
                      {report.total_lifts && report.total_lifts !== '*' && (
                        <div>Total Lifts: {report.total_lifts}</div>
                      )}
                      {report.total_trails && report.total_trails !== '*' && (
                        <div>Total Trails: {report.total_trails}</div>
                      )}
                      {!(report.operation_hours && report.operation_hours !== '*') &&
                        !(report.operation_status && report.operation_status !== '*') &&
                        !(report.resort_status && report.resort_status !== '*') &&
                        !(report.projected_operations && report.projected_operations !== '*') &&
                        !(report.snow_comments24 && report.snow_comments24 !== '*') &&
                        !(report.general_comments && report.general_comments !== '*') &&
                        !(report.night_skiing && report.night_skiing !== '*') &&
                        !(report.num_lift_open && report.num_lift_open !== '*') &&
                        !(report.num_trails_open && report.num_trails_open !== '*') &&
                        !(report.num_miles_open && report.num_miles_open !== '*') &&
                        !(report.num_acres_open && report.num_acres_open !== '*') &&
                        !(report.percent_runs_open && report.percent_runs_open !== '*') &&
                        !(report.cross_country && report.cross_country !== '*') &&
                        !(report.snow_boarding && report.snow_boarding !== '*') &&
                        !(report.total_lifts && report.total_lifts !== '*') &&
                        !(report.total_trails && report.total_trails !== '*') && (
                          <div>No data.</div>
                        )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
